import { createFileRoute } from '@tanstack/react-router'

import { RootRoute } from '@/pages/about-us/route-entries/root-route'
import { buildPageTitle } from '@/utils/seo'

export const Route = createFileRoute('/_layout/about-us')({
  component: RootRoute,
  head: () => {
    return {
      meta: [
        {
          title: buildPageTitle('About us'),
        },
      ],
    }
  },
})
